define("shared/components/shared/wizards/carousel/step-two", ["exports", "@ember/component", "@ember/template-factory", "@ember/component/template-only"], function (_exports, _component, _templateFactory, _templateOnly) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  0; //eaimeta@70e063a35619d71f0,"@ember/component/template-only",0,"@ember/template-factory"eaimeta@70e063a35619d71f

  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    <section class="tOB--wizard">
    {{!-- Image --}}
    <div class="tOB--wizard__left">
      <img class="o--media" src="/assets/images/img--multiPost--slide3.gif">
    </div>
    {{!-- Description --}}
    <div class="tOB--wizard__right">
      <h3 class="tOB--wizard__title">
        {{t "tutorials.multi_image.slide_2.title"}}
      </h3>
      <ul class="tOB--wizard__ul">
        <li class="tOB--wizard__li">
          {{html-safe (t "tutorials.multi_image.slide_2.info")}}
        </li>
        <li class="tOB--wizard__li">
          <span class="u--text--bold"><i class="i--ig u--m__r__sm"></i>{{t "shared_words.instagram"}}</span>
          <p class="u--p__l__lg">
            {{t "tutorials.multi_image.slide_2.instagram_desc"}}
          </p>
        </li>
        <li class="tOB--wizard__li">
          <span class="u--text--bold"><i class="i--twitter u--m__r__sm"></i>{{t "shared_words.twitter"}}</span>
          <p class="u--p__l__lg">
            {{t "tutorials.multi_image.slide_2.twitter_desc"}}
          </p>
        </li>
        <li class="tOB--wizard__li">
          <span class="u--text--bold"><i class="i--facebook u--m__r__sm"></i>{{t "shared_words.facebook"}}</span>
          <p class="u--p__l__lg">
            {{t "tutorials.multi_image.slide_2.facebook_desc"}}
          </p>
        </li>
      </ul>
    </div>
  </section>
  
  */
  {
    "id": "+WNRksf+",
    "block": "[[[10,\"section\"],[14,0,\"tOB--wizard\"],[12],[1,\"\\n\"],[1,\"  \"],[10,0],[14,0,\"tOB--wizard__left\"],[12],[1,\"\\n    \"],[10,\"img\"],[14,0,\"o--media\"],[14,\"src\",\"/assets/images/img--multiPost--slide3.gif\"],[12],[13],[1,\"\\n  \"],[13],[1,\"\\n\"],[1,\"  \"],[10,0],[14,0,\"tOB--wizard__right\"],[12],[1,\"\\n    \"],[10,\"h3\"],[14,0,\"tOB--wizard__title\"],[12],[1,\"\\n      \"],[1,[28,[35,0],[\"tutorials.multi_image.slide_2.title\"],null]],[1,\"\\n    \"],[13],[1,\"\\n    \"],[10,\"ul\"],[14,0,\"tOB--wizard__ul\"],[12],[1,\"\\n      \"],[10,\"li\"],[14,0,\"tOB--wizard__li\"],[12],[1,\"\\n        \"],[1,[28,[35,1],[[28,[37,0],[\"tutorials.multi_image.slide_2.info\"],null]],null]],[1,\"\\n      \"],[13],[1,\"\\n      \"],[10,\"li\"],[14,0,\"tOB--wizard__li\"],[12],[1,\"\\n        \"],[10,1],[14,0,\"u--text--bold\"],[12],[10,\"i\"],[14,0,\"i--ig u--m__r__sm\"],[12],[13],[1,[28,[35,0],[\"shared_words.instagram\"],null]],[13],[1,\"\\n        \"],[10,2],[14,0,\"u--p__l__lg\"],[12],[1,\"\\n          \"],[1,[28,[35,0],[\"tutorials.multi_image.slide_2.instagram_desc\"],null]],[1,\"\\n        \"],[13],[1,\"\\n      \"],[13],[1,\"\\n      \"],[10,\"li\"],[14,0,\"tOB--wizard__li\"],[12],[1,\"\\n        \"],[10,1],[14,0,\"u--text--bold\"],[12],[10,\"i\"],[14,0,\"i--twitter u--m__r__sm\"],[12],[13],[1,[28,[35,0],[\"shared_words.twitter\"],null]],[13],[1,\"\\n        \"],[10,2],[14,0,\"u--p__l__lg\"],[12],[1,\"\\n          \"],[1,[28,[35,0],[\"tutorials.multi_image.slide_2.twitter_desc\"],null]],[1,\"\\n        \"],[13],[1,\"\\n      \"],[13],[1,\"\\n      \"],[10,\"li\"],[14,0,\"tOB--wizard__li\"],[12],[1,\"\\n        \"],[10,1],[14,0,\"u--text--bold\"],[12],[10,\"i\"],[14,0,\"i--facebook u--m__r__sm\"],[12],[13],[1,[28,[35,0],[\"shared_words.facebook\"],null]],[13],[1,\"\\n        \"],[10,2],[14,0,\"u--p__l__lg\"],[12],[1,\"\\n          \"],[1,[28,[35,0],[\"tutorials.multi_image.slide_2.facebook_desc\"],null]],[1,\"\\n        \"],[13],[1,\"\\n      \"],[13],[1,\"\\n    \"],[13],[1,\"\\n  \"],[13],[1,\"\\n\"],[13],[1,\"\\n\"]],[],false,[\"t\",\"html-safe\"]]",
    "moduleName": "shared/components/shared/wizards/carousel/step-two.hbs",
    "isStrictMode": false
  });

  var _default = (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, (0, _templateOnly.default)());

  _exports.default = _default;
});